
<template>
  <div class="container">
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  mounted () {
    if (this.$route.query.code) {
      this.getToken(this.$route.query.code)
    }
  },
  computed: {
    routeInfo: function () {
      return this.$route.query
    }
  },
  data () {
    return { result: '' }
  },
  methods: {
    ...mapActions(['getToken', 'checkSession', 'getProfile'])
  }
}
</script>

<style>
</style>
